import React, {Component} from 'react';
import {Row, Col, Form, FormGroup, ControlLabel} from "react-bootstrap";
import {Link} from "react-router-dom";
import TopIf from "../../../../componentsTopsa/if/TopIf";
import LSService from "../../../../utilities/localStorageService/LSService";
import {TopButtonAction} from "../../../../componentsTopsa/buttons/TopButtons";
import InfoTooltip from "../../../../componentsTopsa/infoTooptip/InfoTooltip";
import KlienciService from "../../KlienciService";
import Select from 'react-select'

export default class WyborKlientForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            klient: null,
            zdj: null
        };
        this.onChangeKlient = this.onChangeKlient.bind(this)
        this.onClickZmienKlienta = this.onClickZmienKlienta.bind(this)
    }

    componentDidMount() {
    }

    componentWillReceiveProps(nextprops) {
        if (Boolean(nextprops.nowoUtworzony)) {
            this.setState({
                klient: nextprops.nowoUtworzony
            })
        }
        // gdy edytowany jest wpis
        if (Boolean(nextprops.czyEdycja)) {
            if ((this.props.wstrzymajOdswiezanie && Boolean(this.state.klient))) {

            }
            else {
                KlienciService.getKlient(nextprops.edytowanyKlient.idKl).then(function (response) {

                    if (response) {


                        let profilowe = null

                        if (response.data.pliki.length > 0) {
                            if (Boolean(response.data.pliki.find(p => p.dokumentTyp == 'KLIENT_ZDJECIE'))) {
                                profilowe = (response.data.pliki.find(p => p.dokumentTyp == 'KLIENT_ZDJECIE')).dane
                            }
                        }

                        let kl = nextprops.edytowanyKlient
                        kl.zdjecie = profilowe
                        this.setState({klient: kl})
                    }
                    else {
                        this.setState({klient: nextprops.edytowanyKlient})
                    }
                }.bind(this))
            }

        }
        if (Boolean(nextprops.klient)) {
            this.setState({klient: nextprops.klient})
        }
    }

    onClickZmienKlienta() {
        this.setState({klient: null})
        this.props.handleZmienKlienta()
    }

    onChangeKlient(e) {
        if(e!==null){
            KlienciService.getKlient(e.idKl).then(function (response) {


                let profilowe = null

                if (response.data.pliki.length > 0) {
                    if (Boolean(response.data.pliki.find(p => p.dokumentTyp == 'KLIENT_ZDJECIE'))) {
                        profilowe = (response.data.pliki.find(p => p.dokumentTyp == 'KLIENT_ZDJECIE')).dane
                    }
                }


                let kl = e
                kl.zdjecie = profilowe


                this.setState({klient: kl})
                this.props.handleChangeKlient(kl)

            }.bind(this)).catch(function (err) {
                console.log(err)
            }.bind(this))
        }
    }

    renderKlientOption(option, czyPokazacZdj) {
        if (option.idKl === 1) {
            return <span title={'Imie i nazwisko klienta'}><span className={'label label-ebus-primary'}>{option.imieNazwisko}</span></span>
        }
        else {
            return <div>
                {Boolean(option.imie) ?
                    <span title={'Imie i nazwisko klienta'}><span className={'label label-ebus-primary'}>{option.imieNazwisko}</span></span> : ''}
                {Boolean(option.pesel) ?
                    <span title={'PESEL'} style={{marginLeft: '15px'}}><i className={'fa fa-id-card-o'}></i> {option.pesel}</span> : ''}
                {Boolean(option.email) ?
                    <span title={'PESEL'} style={{marginLeft: '15px'}}><i className={'fa fa-envelope-o'}></i> {option.email}</span> : ''}
                {Boolean(option.nrTel) ?
                    <span title={'Telefon'} style={{marginLeft: '15px'}}><i className={'fa fa-phone'}></i> {option.nrTel}</span> : ''}
            </div>
        }
    }

    getUsers(input) {
        if (!input) {
            return Promise.resolve({options: []})
        }

        return KlienciService.getKlienciBezZdjec(input).then(function (response) {

            let arr = Array.from(response.data.content, item => {
                return {
                    ...item,
                    informacje: item.imie + ' ' + item.nazwisko + ' ' + item.pesel,
                    imieNazwisko: item.imie + ' ' + item.nazwisko,
                    wszystko: item.imie + ' ' + item.nazwisko + ' ' + item.pesel + ' ' + item.nrTel + ' ' + item.email
                }
            })
            return {options: arr}
        }.bind(this))
    }

    render() {
        if (this.props.dostosujPodJednorazowe) {
            return (
                <div>
                    <ControlLabel style={{paddingTop: 0}}>Klient
                        <InfoTooltip label={' '} text={'Można szukać po: imię, nazwisko, pesel, telefon, email'}/>
                    </ControlLabel>
                    <span style={{marginLeft: '15px'}}>
                    <Link to={'/zarzadzanie-klientami/klienci'} style={{lineHeight: '34px'}} onClick={() => {
                        LSService.przeslijInformacjeODodaniuKlientaPrzezDodawanieBiletowJed()
                    }}><i
                        className={'fa fa-external-link'}></i> Dodaj nowego klienta</Link>
                    </span>
                    <Select.Async value={this.state.klient} onChange={this.onChangeKlient} valueKey="idKl"
                                  labelKey="wszystko" loadOptions={this.getUsers} clearable={false}
                                  backspaceRemoves={true}
                                  placeholder={'Szukaj po nazwisku, pesel, email'}

                                  valueRenderer={(option) => this.renderKlientOption(option, false)}
                                  optionRenderer={(option) => this.renderKlientOption(option, true)}
                                  ignoreAccents={false}
                    />

                    <div>
                        {
                            Boolean(this.state.klient) ?
                                (this.state.klient.idKl !== 1) ?
                                    <div style={{marginTop: '15px'}}>
                                        <div className={'thumbnail'} style={{padding: '15px'}}>
                                            <Row>
                                                <Col xs={12} lg={4}>
                                                    <div className={'thumbnail'} style={{marginBottom: 0}}>
                                                        {
                                                            Boolean(this.state.klient.zdjecie) ?
                                                                <img src={'data:image/jpg;base64,' + this.state.klient.zdjecie}
                                                                     className={'img-ressponsive'}/>
                                                                :
                                                                <div>
                                                                    {/*<DodajZdjecieComponent klient={this.props.klient}/>*/}
                                                                    <p style={{textAlign:'center',padding:'20px 0', color:'#f0ad4e'}}>
                                                                        <i className={'fa fa-exclamation-circle'}></i> Brak zdjęcia
                                                                    </p>
                                                                </div>
                                                        }
                                                    </div>
                                                </Col>
                                                <Col xs={12} lg={8}>
                                                    <p style={{marginTop: '15px'}}>
                                                        <span><i className={'fa fa-user'}></i> Imie i nazwisko:</span>
                                                        <label>{this.state.klient.imieNazwisko}</label>
                                                    </p>
                                                    <TopIf isTrue={this.state.klient.pesel}>
                                                        <p>
                                                            <span><i className={'fa fa-id-card-o'}></i> Nr Pesel:</span>
                                                            <label>{this.state.klient.pesel}</label>
                                                        </p>
                                                    </TopIf>
                                                    <TopIf isTrue={this.state.klient.nrTel}>
                                                        <p>
                                                            <span><i className={'fa fa-phone'}></i> Telefon:</span>
                                                            <label>{this.state.klient.nrTel}</label>
                                                        </p>
                                                    </TopIf>
                                                    <TopIf isTrue={this.state.klient.email}>
                                                        <p>
                                                            <span><i className={'fa fa-envelope'}></i> Email:</span>
                                                            <label>{this.state.klient.email}</label>
                                                        </p>
                                                    </TopIf>
                                                </Col>
                                            </Row>
                                        </div>
                                    </div>
                                    : ''
                                :
                                ''
                        }
                    </div>
                </div>
            )
        }
        else
            return (
                <div style={{marginTop: '15px'}}>
                    <fieldset>
                        <div className={'fieldset-label'}>Szczegóły klienta</div>
                        <Form horizontal={true}>
                            {
                                Boolean(this.props.nowoUtworzony) ?
                                    <FormGroup>
                                        <Col xs={8} lg={4}>
                                            <TopButtonAction iconType={'fa fa-user-plus'} btnSize={'medium'} text={'Zmień klienta'}
                                                             onClick={this.onClickZmienKlienta}/>
                                        </Col>
                                    </FormGroup>
                                    :
                                    <FormGroup>
                                        <Col xs={8} lg={4}>
                                            <ControlLabel>Klient <InfoTooltip label={' '}
                                                                              text={'Można szukać po: imię, nazwisko, pesel, telefon, email'}/></ControlLabel>
                                            {/*<TopSelect onChange={this.onChangeKlient} value={this.state.klient} options={this.props.klienci}
                                                       valueKey={'idKl'} labelKey={'wszystko'}
                                                       valueRenderer={(option) => this.renderKlientOption(option, false)}
                                                       optionRenderer={(option) => this.renderKlientOption(option, true)}
                                                       clearable={false} placeholder={'Szukaj klienta po imieniu, nazwisku, pesel, telefon, email...'}
                                            />*/}

                                            <Select.Async value={this.state.klient} onChange={this.onChangeKlient} valueKey="idKl"
                                                          labelKey="wszystko" loadOptions={this.getUsers}
                                                          backspaceRemoves={true} clearable={false}
                                                          placeholder={'Szukaj po nazwisku, pesel, email'}
                                                          ignoreAccents={false}

                                                          valueRenderer={(option) => this.renderKlientOption(option, false)}
                                                          optionRenderer={(option) => this.renderKlientOption(option, true)}
                                            />

                                        </Col>
                                        <Col xs={4} lg={4}>
                                            <div className={'add-label-margin'}></div>
                                            <Link to={'/zarzadzanie-klientami/klienci'} style={{lineHeight: '34px'}} onClick={() => {
                                                LSService.przeslijInformacjeODodaniuKlientaPrzezDodawanieBiletowMsc()
                                            }}><i
                                                className={'fa fa-external-link'}></i> Dodaj nowego klienta</Link>
                                        </Col>
                                    </FormGroup>
                            }

                            {
                                Boolean(this.state.klient) ?
                                    <FormGroup>
                                        <Col xs={12} lg={4}>
                                            <div className={'thumbnail'} style={{padding: '15px'}}>
                                                <Row>
                                                    <Col xs={12} lg={4}>
                                                        <div className={'thumbnail'} style={{marginBottom: 0}}>
                                                            {
                                                                Boolean(this.state.klient.zdjecie) ?
                                                                    <img src={'data:image/jpg;base64,' + this.state.klient.zdjecie}
                                                                         className={'img-ressponsive'}/>
                                                                    :
                                                                    <div>
                                                                        {/*<DodajZdjecieComponent klient={this.props.klient}/>*/}
                                                                        <p style={{textAlign:'center',padding:'20px 0', color:'#f0ad4e'}}>
                                                                            <i className={'fa fa-exclamation-circle'}></i> Brak zdjęcia
                                                                        </p>
                                                                    </div>
                                                            }
                                                        </div>
                                                    </Col>
                                                    <Col xs={12} lg={8}>
                                                        <p>
                                                            <span><i className={'fa fa-user'}></i> Imie i nazwisko:</span>
                                                            <label>{this.state.klient.imieNazwisko}</label>
                                                        </p>
                                                        <TopIf isTrue={this.state.klient.pesel}>
                                                            <p>
                                                                <span><i className={'fa fa-id-card-o'}></i> Nr Pesel:</span>
                                                                <label>{this.state.klient.pesel}</label>
                                                            </p>
                                                        </TopIf>
                                                        <TopIf isTrue={this.state.klient.nrTel}>
                                                            <p>
                                                                <span><i className={'fa fa-phone'}></i> Telefon:</span>
                                                                <label>{this.state.klient.nrTel}</label>
                                                            </p>
                                                        </TopIf>
                                                        <TopIf isTrue={this.state.klient.email}>
                                                            <p>
                                                                <span><i className={'fa fa-envelope'}></i> Email:</span>
                                                                <label>{this.state.klient.email}</label>
                                                            </p>
                                                        </TopIf>
                                                    </Col>
                                                </Row>
                                            </div>
                                        </Col>
                                    </FormGroup>
                                    :
                                    ''
                            }

                        </Form>
                    </fieldset>
                </div>
            );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/klienci/externalComponents/WyborKlientForm.js